/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__Zone_disable_customElements = true;
// ci: prove rideops App Service staging deploy (mobaro-rideops-app slot). Safe to remove.
